import { configureStore } from "@reduxjs/toolkit";
import {
  useSelector as rawUseSelector,
  TypedUseSelectorHook,
  useDispatch
} from "react-redux";

import authReducer from './features/authSlice'
import systemReducer from "./features/systemSlice";
import tabReducer from './features/tabsSlice'
import filterReducer from './features/filterSlice'
import chatbotReducer from "./features/chatbotSlice";
import genieReducer from './features/genieSlice'
import map2Reducer from './features/map2Slice'
import transmissionReducer from './features/transmissionSlice'
import agentAssistantReducer from './features/agentAssistantSlice'
import { reportApi } from './services/reportApi'
import { chatApi } from './services/chatservice'
import { dataApi } from './services/dataservice'
import { mapApi } from "./services/mapservice";
import { chatLog } from "./services/chatlog";
import { genieApi } from "./services/genieservice";
import { map2Api } from "./services/map2service";
import { agentAssistantApi } from "./services/agentAssistantService";
// import { transmissionApi } from "./services/transmissionService";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    system: systemReducer,
    reportTabs: tabReducer,
    filterReports: filterReducer,
    chatbot: chatbotReducer,
    genie: genieReducer,
    map2: map2Reducer,
    transmission: transmissionReducer,
    agentAssistant: agentAssistantReducer,
    [reportApi.reducerPath]: reportApi.reducer,
    [chatApi.reducerPath]: chatApi.reducer,
    [dataApi.reducerPath]: dataApi.reducer,
    [mapApi.reducerPath]: mapApi.reducer,
    [chatLog.reducerPath]: chatLog.reducer,
    [genieApi.reducerPath]: genieApi.reducer,
    [map2Api.reducerPath]: map2Api.reducer,
    [agentAssistantApi.reducerPath]: agentAssistantApi.reducer,
    // [transmissionApi.reducerPath]: transmissionApi.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware()
    .concat(reportApi.middleware)
    .concat(chatApi.middleware)
    .concat(dataApi.middleware)
    .concat(mapApi.middleware)
    .concat(chatLog.middleware)
    .concat(genieApi.middleware)
    .concat(map2Api.middleware)
    .concat(agentAssistantApi.middleware),
    // .concat(transmissionApi.middleware),
  devTools: process.env.NODE_ENV !== 'production'
});

export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<typeof store.dispatch>()
export type RootState = ReturnType<typeof store.getState>;
export const useSelector: TypedUseSelectorHook<RootState> = rawUseSelector;

